module.exports = __webpack_public_path__ + "img/tradeTicket1.8b5b03a7.jpg";